import React from 'react';
import OtherBanner from '../components/OtherBanner';
import ContactDetails from '../components/ContactDetails';
import QuickPoint from '../components/QuickPoint';
import DownloadApp from '../components/DownloadApp';

import contactBanner from '../assets/img/contact-banner.png';
import ContactForm from '../components/ContactForm';


const Contact = () => {
    return (
        <>
            <OtherBanner
                image={contactBanner}
                title="TESTIGO MOBILE MEDICAL DIAGNOSTICS"
                text="Get in touch with us Call Us at: 999-888-000-5 Helpline No.: 1800-572-0005"
            />
            <ContactDetails />
            <ContactForm />
            <QuickPoint
                text="Moving equipment not patients. For more information call us"
                phoneNo="087 056 4412"
            />
            <DownloadApp />
        </>
    );
};

export default Contact;